export function getRandomString(bytes: number): string {
  if (typeof window === 'undefined' || !window.crypto) {
    throw new Error('getRandomString requires window.crypto (browser)');
  }

  const array = new Uint8Array(bytes);
  const outputArray = window.crypto.getRandomValues(array);
  const hexString = Array.from(outputArray, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return hexString;
}
